import { useDraggable } from '@dnd-kit/core';
import { BLOCK_DEFS, PALETTE_GROUPS } from './blockSchema.js';
import { useEditor } from './editorStore.js';

// Renders inside LeftSidebar's tab body. The outer aside lives in LeftSidebar.
export default function BlockPalette() {
  const addBlock = useEditor((s) => s.addBlock);

  return (
    <div className="p-3">
      {PALETTE_GROUPS.map((group) => (
        <div key={group.label} className="mb-4">
          <div className="mb-2 px-2 text-[10px] font-semibold uppercase tracking-wider text-ink-400">
            {group.label}
          </div>
          <div className="grid grid-cols-2 gap-2">
            {group.types.map((type) => (
              <PaletteItem
                key={type}
                type={type}
                onClick={() => addBlock(type)}
              />
            ))}
          </div>
        </div>
      ))}

      <div className="mt-2 rounded-lg border border-dashed border-ink-200 bg-ink-50 p-3 text-xs text-ink-500 dark:border-ink-800 dark:bg-ink-950">
        Drag a block onto the canvas, or click to append it.
      </div>
    </div>
  );
}

function PaletteItem({ type, onClick }) {
  const def = BLOCK_DEFS[type];
  const { attributes, listeners, setNodeRef, isDragging } = useDraggable({
    id: `palette-${type}`,
    data: { source: 'palette', type },
  });

  return (
    <button
      type="button"
      ref={setNodeRef}
      onClick={onClick}
      {...listeners}
      {...attributes}
      className={
        'flex flex-col items-start gap-2 rounded-lg border border-ink-200 bg-white p-3 text-left text-xs font-medium shadow-soft transition hover:border-brand-400 hover:bg-brand-50 dark:border-ink-800 dark:bg-ink-900 dark:hover:bg-ink-800 ' +
        (isDragging ? 'opacity-40' : '')
      }
    >
      <span className="text-base text-ink-400">{def.icon}</span>
      <span>{def.label}</span>
    </button>
  );
}
